import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';

import { AuthGuard } from './services/guards/auth.guard';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/pages/appointment-form',
        pathMatch: 'full',
      }
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'pages',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
      }
    ],
  }
];

